import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface OrderTargetsLoadErrorProps {
  message: LangEnum;
  onRetry: () => void;
}

const OrderTargetsLoadError = ({ message, onRetry }: OrderTargetsLoadErrorProps) => {
  const { translate } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', justifyContent: 'space-between', gap: 1, paddingInline: 1.5 }}
    >
      <Typography variant="body2" color="textSecondary">
        {translate(message)}
      </Typography>
      <Button variant="text" color="secondary" size="small" onClick={onRetry}>
        {translate(LangEnum.GLOBAL_TRY_AGAIN)}
      </Button>
    </Stack>
  );
};

export default OrderTargetsLoadError;
